<template>
  <a-modal
    :title="`岗位用户 - ${position.name || ''}`"
    :visible="visible"
    :footer="null"
    width="1000px"
    @cancel="close"
  >
    <!-- 添加用户 -->
    <div class="add-bar">
      <user-select v-model="selectedUserId" @select="onUserSelect" style="width: 240px" />
      <a-checkbox :checked="isPrimary" @change="(e) => (isPrimary = e.target.checked)">设为主岗位</a-checkbox>
      <a-date-picker
        v-model="expireDate"
        placeholder="失效时间（不选=永久）"
        style="width: 180px"
        value-format="YYYY-MM-DD"
      />
      <a-button type="primary" :disabled="!selectedUserId" :loading="assigning" @click="assign">
        添加
      </a-button>
    </div>
    <div class="add-tip">主岗位分配会自动回收该用户旧主岗位的角色与数据权限</div>

    <a-divider style="margin: 12px 0" />

    <a-table
      bordered
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :dataSource="users"
      :pagination="false"
    >
      <template slot="primaryCol" slot-scope="text">
        <a-tag v-if="text" color="blue">主岗位</a-tag>
        <a-tag v-else>兼职</a-tag>
      </template>
      <template slot="statusCol" slot-scope="text">
        <a-badge :status="text === 'active' ? 'success' : 'warning'" :text="statusName(text)" />
      </template>
      <template slot="expireCol" slot-scope="text">
        {{ text || "永久" }}
      </template>
      <template slot="actionCol" slot-scope="text, record">
        <a class="danger-link" @click="removeUser(record)">移除</a>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { fetchPositionUsers, assignUserPosition, removeUserPosition } from "@/api/setting/auth";
import UserSelect from "./user-select";

export default {
  name: "position-user-modal",

  components: { UserSelect },

  props: {
    visible: { type: Boolean, default: false },
    // 岗位对象（需要id、name）
    position: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      assigning: false,
      users: [],
      selectedUserId: undefined,
      selectedUser: null,
      isPrimary: false,
      expireDate: null,
      columns: [
        { title: "姓名", dataIndex: "userName", width: 110 },
        { title: "部门", dataIndex: "deptName", width: 160 },
        { title: "主/兼", dataIndex: "isPrimary", width: 80, align: "center", scopedSlots: { customRender: "primaryCol" } },
        { title: "状态", dataIndex: "status", width: 90, align: "center", scopedSlots: { customRender: "statusCol" } },
        { title: "生效时间", dataIndex: "effectiveAt", width: 150 },
        { title: "失效时间", dataIndex: "expireAt", width: 150, scopedSlots: { customRender: "expireCol" } },
        { title: "操作", width: 70, align: "center", scopedSlots: { customRender: "actionCol" } },
      ],
    };
  },

  watch: {
    visible(val) {
      if (val) {
        this.selectedUserId = undefined;
        this.selectedUser = null;
        this.isPrimary = false;
        this.expireDate = null;
        this.load();
      }
    },
  },

  methods: {
    statusName(status) {
      const map = { active: "生效中", pending: "待生效", expired: "已过期" };
      return map[status] || status;
    },
    load() {
      if (!this.position.id) {
        return;
      }
      this.loading = true;
      fetchPositionUsers(this.position.id)
        .then((res) => {
          this.users = Array.isArray(res) ? res : [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onUserSelect(user) {
      this.selectedUser = user;
    },
    assign() {
      this.assigning = true;
      assignUserPosition({
        userId: this.selectedUserId,
        positionId: this.position.id,
        isPrimary: this.isPrimary,
        expireAt: this.expireDate || null,
        // 用户姓名冗余存储，便于岗位用户列表直读
        remarks: this.selectedUser && this.selectedUser.name ? `分配人：${this.selectedUser.name}` : null,
      })
        .then(() => {
          this.$message.success("分配成功");
          this.selectedUserId = undefined;
          this.selectedUser = null;
          this.isPrimary = false;
          this.expireDate = null;
          this.load();
        })
        .catch(() => {})
        .finally(() => {
          this.assigning = false;
        });
    },
    removeUser(record) {
      const that = this;
      this.$confirm({
        title: `确认将用户「${record.userName}」移出岗位「${this.position.name}」吗？`,
        content: "移除后该用户将失去此岗位绑定的角色与数据权限。",
        onOk() {
          return removeUserPosition({ userId: record.userId, positionId: that.position.id }).then(() => {
            that.$message.success("移除成功");
            that.load();
          });
        },
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.add-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.add-tip {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.danger-link {
  color: #f5222d;
}
</style>
